import { memo } from 'react';
import { cn } from '../../../utils/string/cn.utils';

const ButtonIconOutlineMedium = ({ id, icon, ...props }) => {
  return (
    <button
      id={id}
      type="button"
      {...props}
      className={cn(
        'disabled:cursor-not-allowed disabled:pointer-events-none bg-fills-white border-[1px] border-solid border-outline-default-secondary flex justify-center items-center hover:border-outline-brand-primary hover:bg-primary-primaryFill disabled:border-outline-default-disable disabled:text-black-low disabled:bg-fills-disable text-black-high',
        'gap-[10px] w-[32px] h-[32px] p-[6px] rounded-[100px]',
        props.className
      )}
    >
      {icon && (
        <div className="w-20 h-20 flex justify-center items-center">{icon}</div>
      )}
    </button>
  );
};

export default memo(ButtonIconOutlineMedium);
